<template>
  <div id="app">
    <LangNavbar class="lang-nav-bar--right-top" v-if="hasLangNavBar" />
    <router-view />
  </div>
</template>

<script>
import LangNavbar from '@/layout/LangNavbar.vue';
export default {
  name: 'App',
  components: { LangNavbar },
  computed: {
    hasLangNavBar() {
      return this.$route.meta.lang_navbar;
    }
  },
  watch: {
    $route() {
      this.handleLayout();
    }
  },
  created() {
    this.handleLayout();
  },
  methods: {
    handleLayout() {
      if (this.$route.meta.fullScreen) {
        document.body.classList.remove('has-navbar-fixed-top-temp');
        document.body.classList.add('is-fullscreen');
      } else {
        document.body.classList.add('has-navbar-fixed-top-temp');
        document.body.classList.remove('is-fullscreen');
      }
      if (this.$route.meta.layout === 'AuthLayout') {
        console.log('xto', this.$route.meta);
      }
    }
  }
};
</script>
